import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';

const firebaseConfig = {
    // apiKey: "AIzaSyDtzsbMoDbarOtfGi9r-EWLOyNKLfyg-t4",
    // authDomain: "testpocketpay.firebaseapp.com",
    // projectId: "testpocketpay",
    // storageBucket: "testpocketpay.firebasestorage.app",
    // messagingSenderId: "747693330432",
    // appId: "1:747693330432:web:7c019c86e23263f8b348e5",
    // measurementId: "G-DCM9NB6Z6B"

    apiKey: "AIzaSyC6jqPy0hBfuCIxGBzR9EneOLB0u-wwGoA",
    authDomain: "pagarbook-72363.firebaseapp.com",
    projectId: "pagarbook-72363",
    storageBucket: "pagarbook-72363.firebasestorage.app",
    messagingSenderId: "33057224977",
    appId: "1:33057224977:web:08cc134635759e4ace74b0",
    measurementId: "G-ZD8TBXJJY3"
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export const messaging = firebase.messaging();
export default firebase;
